export const importQuestionCSVHeaderkeyMap: {[key: string]: string} = {
    'Global Id': 'globalId',
    'Locale': 'locale',
    'English Title': 'englishTitle',
    'Translated Title': 'translatedTitle'
};
